import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/filter-icon.svg'
import _imports_1 from '../../../assets/icons/download-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-8cec331e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analytics__wrapper tw-pb-12" }
const _hoisted_2 = { class: "analytics__header md:!tw-flex-col" }
const _hoisted_3 = { class: "header__date rmd:!tw-w-[400px]" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_5 = { class: "icon_btn" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "icon_btn" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))

import { ref, onBeforeMount, watch } from "vue";
import { useStore } from "vuex";

import EstimatesJobsRatingCardsLayout from "../components/EstimatesJobsRatingCardsLayout.vue";
import RevenueCardsLayout from "../components/RevenueCardsLayout.vue";
import ServiceCardsLayout from "../components/ServiceCardsLayout.vue";
import TeamPerformanceCard from "../components/TeamPerformanceCard.vue";
import { ANALYTICS_STORE } from "@/store/modules/analytics";
import InputSelect from "@/core/uni-components/InputSelect.vue";
import Loader from "@/core/components/common/Loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticsPage',
  setup(__props) {

const store = useStore();

const dateValue = ref(null);
const categoryFilterValue = ref("Monthly");
const filterItems = ref([{ range: "Monthly" }, { range: "Yearly" }]);
const loadingData = ref(false);

const fetchTradeAnalytics = async () => {
  loadingData.value = true;
  let startDate = "2020-01-01"; // default date range
  let endDate = "2025-12-31"; // default date range
  let params = {};
  if (dateValue.value) {
    startDate = dateValue.value[0];
    endDate = dateValue.value[1];
  }

  params = {
    startDate,
    endDate,
  };

  try {
    await store.dispatch(`${ANALYTICS_STORE}/fetchTradeAnalytics`, params);
    await store.dispatch(`${ANALYTICS_STORE}/fetchServiceRevenue`, params);
    await store.dispatch(`${ANALYTICS_STORE}/fetchTeamPerformance`, params);
  } catch (error) {
    console.log(error);
  } finally {
    loadingData.value = false;
  }
};

watch(
  () => dateValue.value,
  async (newValue) => {
    if (newValue) {
      console.log("runned");
      await fetchTradeAnalytics();
    }
  },

  { immediate: true, deep: true }
);

onBeforeMount(async () => {
  await fetchTradeAnalytics();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (categoryFilterValue.value === 'Monthly')
          ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 0,
              modelValue: dateValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
              type: "daterange",
              "range-separator": "-",
              "value-format": "YYYY-MM-DD",
              "start-placeholder": "Start date",
              "end-placeholder": "End date",
              size: "large"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (categoryFilterValue.value === 'Yearly')
          ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 1,
              modelValue: dateValue.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateValue).value = $event)),
              "value-format": "YYYY-MM-DD",
              type: "monthrange",
              size: "large",
              "range-separator": "|",
              "start-placeholder": "Start month",
              "end-placeholder": "End month"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_select, {
          items: filterItems.value,
          modelValue: categoryFilterValue.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((categoryFilterValue).value = $event)),
          "item-title": "range",
          "item-value": "range",
          variant: "outlined",
          placeholder: "Monthly",
          "bg-color": "#fff",
          class: "input_field",
          type: "select"
        }, null, 8, ["items", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            class: "button",
            variant: "outlined",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createTextVNode("Filter")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_btn, {
            class: "button",
            variant: "outlined",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createTextVNode(" Export ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (!loadingData.value)
      ? (_openBlock(), _createBlock(EstimatesJobsRatingCardsLayout, { key: 0 }))
      : _createCommentVNode("", true),
    (!loadingData.value)
      ? (_openBlock(), _createBlock(RevenueCardsLayout, { key: 1 }))
      : _createCommentVNode("", true),
    (!loadingData.value)
      ? (_openBlock(), _createBlock(ServiceCardsLayout, { key: 2 }))
      : _createCommentVNode("", true),
    (!loadingData.value)
      ? (_openBlock(), _createBlock(TeamPerformanceCard, { key: 3 }))
      : _createCommentVNode("", true),
    _createVNode(Loader, { show: loadingData.value }, null, 8, ["show"])
  ]))
}
}

})